var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "splitTipPopover",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("div", { staticClass: "tiptitle" }, [_vm._v("确认拆分此订单吗？")]),
      _c("div", { staticClass: "y-fc-F32F52 y-t-al" }, [
        _vm._v("1、拆分订单后，系统将清空该订单已打印的运单号"),
      ]),
      _c("div", { staticClass: "y-fc-F32F52 y-t-al" }, [
        _vm._v("2、如果你开启了自动合单，无法触发拆单"),
      ]),
      _c(
        "div",
        { staticClass: "y-t-ar y-mt-10" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }